import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupFilterComponent } from './group-filter.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [GroupFilterComponent],
  exports: [
      GroupFilterComponent
  ]
})
export class GroupFilterModule { }



// WEBPACK FOOTER //
// ./src/app/group-filter/group-filter.module.ts